<template>
  <section class="cart">
    <modal
      v-if="loading"
      no-close
      center-content
    >
      <loader-spinner :size="1.5" />
      <template #footer>
        <span v-html="$t('loading')" />
      </template>
    </modal>

    <header class="cart__header">
      <headline level="2">
        {{ $t('title') }}
      </headline>

      <p>
        <action-link
          color="primary"
          class="cart__download-button"
          @click="downloadReservation()"
        >
          <span v-html="$t('download')" />
          <icon type="file-pdf" />
        </action-link>
      </p>

      <p>
        <a
          :href="walletLink"
          target="_blank"
        >
          <img
            :src="walletImageSrc"
            alt="Apple Wallet"
            width="160"
          >
        </a>
      </p>
    </header>

    <div class="cart__content">
      <h2>{{ $t('wallet.title') }}</h2>
      <p>
        <span v-html="$t('wallet.information')" />
        <a
          :href="walletLink"
          target="_blank"
        >{{ $t('wallet.linkText') }}</a>.
      </p>
      <p><small>{{ $t('wallet.trademark') }}</small></p>
    </div>

    <div class="cart__footer">
      <action-link
        :href="$t('homepage.link')"
        color="secondary"
        @click="setCookie"
      >
        {{ $t('homepage.text') }}
      </action-link>
    </div>
  </section>
</template>

<script>
import cartMixin from '../mixins/cart'

import cookie from '../functions/cookie'

import actionLink from './actionLink.vue'
import headline from './headline.vue'
import icon from './icon.vue'

import { BASE_URL, API_URL } from '../settings.js'

export default {
  name: 'CCartReservationDownload',

  components: {
    actionLink,
    headline,
    icon
  },

  mixins: [cartMixin],

  props: {
    barcode: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    walletImageSrc () {
      return `${BASE_URL}static/img/apple-wallet-${this.$i18n.locale}.svg`
    },

    walletLink () {
      return `${API_URL}download/${this.barcode}/wallet/`
    }
  },

  methods: {
    setCookie () {
      cookie()
    },

    downloadReservation () {
      const downloadUrl = `${API_URL}download/${this.barcode}/pdf/?download=1&language=${this.$i18n.locale}`
      window.open(downloadUrl)
    }
  }
}
</script>

<i18n locale="en">
{
  "title": "Your Reservation for Download",
  "download": "Download <strong>Reservation</strong>",
  "homepage": {
    "text": "Go to Website",
    "link": "http://www.miniatur-wunderland.com/"
  },
  "wallet": {
    "title": "Save tickets on your smartphone",
    "information": "You can save your tickets on your iPhone or Android smartphone with the Apple Wallet App or <a href=\"https://play.google.com/store/search?q=wallet\" target=\"_blank\" rel=\"noopener\">any Android compatible app</a>. Click here to",
    "linkText": "download the Apple Wallet ticket",
    "trademark": "Apple and iPhone are trademarks of Apple Inc., registered in the U.S. and other countries."
  }
}
</i18n>

<i18n locale="de">
{
  "title": "Ihre Reservierung zum Download",
  "download": "<strong>Reservierung</strong> herunterladen",
  "homepage": {
    "text": "Zur Webseite",
    "link": "http://www.miniatur-wunderland.de/"
  },
  "wallet": {
    "title": "Tickets auf dem Smartphone speichern",
    "information": "Sie können sich Ihre Tickets auch bequem auf Ihrem iPhone oder Android Smartphone in der Apple Wallet App oder einer <a href=\"https://play.google.com/store/search?q=wallet\" target=\"_blank\" rel=\"noopener\">mit Android kompatiblen App</a> speichern. Hier können Sie sich",
    "linkText": "das Apple Wallet Ticket herunterladen",
    "trademark": "Apple und iPhone sind Marken der Apple Inc., die in den USA und weiteren Ländern eingetragen sind."
  }
}
</i18n>
